import type { PresetDate } from '@vuepic/vue-datepicker'

import { useDayjs } from '@shared/lib/format'

const dayjs = useDayjs()

const daysBack = (days: number): Date[] => [
  dayjs().subtract(days, 'day').startOf('day').toDate(),
  dayjs().endOf('day').toDate(),
]

/**
 * The quick ranges of the legacy date filter. Each is a getter, so "Today" is the day the admin clicks it, not the day
 * the page was opened.
 */
export const DATE_RANGE_PRESETS: PresetDate[] = [
  { label: 'Today', value: () => daysBack(0) },
  {
    label: 'Yesterday',
    value: () => [
      dayjs().subtract(1, 'day').startOf('day').toDate(),
      dayjs().subtract(1, 'day').endOf('day').toDate(),
    ],
  },
  { label: 'Last 3 days', value: () => daysBack(2) },
  { label: 'Last 7 days', value: () => daysBack(6) },
  { label: 'Last 30 days', value: () => daysBack(29) },
  { label: 'This month', value: () => [dayjs().startOf('month').toDate(), dayjs().endOf('month').toDate()] },
  {
    label: 'Last month',
    value: () => [
      dayjs().subtract(1, 'month').startOf('month').toDate(),
      dayjs().subtract(1, 'month').endOf('month').toDate(),
    ],
  },
  { label: 'This year', value: () => [dayjs().startOf('year').toDate(), dayjs().endOf('year').toDate()] },
]
